// extracted by mini-css-extract-plugin
export var cardHeader = "_k0-1";
export var contentCard = "_k0-0";
export var headerActions = "_k0-3";
export var reorderHandle = "_k0-5";
export var titleArea = "_k0-2";
export var titleAreaWithHandle = "_k0-4";